import { cn } from '@ui/lib/utils';
import React, { ReactElement, ReactNode } from 'react';

/**
 * One titled box on a sprint report: the summary, or a remark standing beside it.
 *
 * Both go through here so the two cannot drift apart. They take an equal share of their row rather than
 * sizing to their contents, share a floor, and their titles sit inside them, which keeps the
 * pair level and costs the card no height for a heading.
 */
export const ReportNoteBox = ({
  title,
  meta,
  tone = 'plain',
  children,
}: {
  title: string;
  /** A caption on the title's own line, right-aligned: who wrote this, and when. */
  meta?: string;
  /** `warning` for something the report is waiting on, rather than a settled part of it. */
  tone?: 'plain' | 'warning';
  children: ReactNode;
}): ReactElement => (
  <div
    className={cn(
      'min-h-28 min-w-0 flex-1 basis-0 rounded-lg border p-4',
      tone === 'warning' ? 'border-dashed border-destructive/70' : 'border-border bg-background',
    )}
  >
    <div className="flex flex-wrap items-baseline justify-between gap-x-3">
      <span className="text-sm font-semibold text-foreground">{title}</span>
      {meta && <span className="text-xs text-muted-foreground">{meta}</span>}
    </div>
    <div className="mt-2 text-sm text-muted-foreground">{children}</div>
  </div>
);
